import { ServicePageTemplate } from "@/components/services/ServicePageTemplate";
import { servicePages } from "@/data/servicePages";

const data = servicePages.find((s) => s.slug === "monthly-bookkeeping-services")!;
const MonthlyBookkeepingServices = () => <ServicePageTemplate data={data} />;
export default MonthlyBookkeepingServices;
